import React from 'react';
import format from 'string-template';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import {
    BRAND_NAME,
    CONTEXT_ROOT,
    IS_DEV,
    STATIC_ROOT,
    URL_PAGE_FACEBOOK,
    URL_PAGE_GOOGLEPLUS,
    URL_PAGE_TWITTER
} from '../../constants';
import { PATH } from '../../constants/path';
import LocalizedNavLink from '../router/LocalizedNavLink';
import { DEFAULT_LOCALE, LOCALES } from '../../constants/locale';

import './FooterComponent.scss';

const unlocalizedCurrentPath = () =>
    LOCALES.reduce((acc, cur) => acc.replace(`/${cur}/`, '/'), window.location.pathname);

class FooterComponent extends React.Component {
    renderDevLanguageLink = () => {
        if (LOCALES.length) {
            return (
                <div>
                    Changer de langue :
                    {/* On force un reload de l'app pour changer de langue, seule solution trouvé pour le moment pour que le changement soit effectif */}
                    {LOCALES.map((locale, i, all) => (
                        <a
                            href={`${CONTEXT_ROOT}${
                                locale === DEFAULT_LOCALE ? '' : `/${locale}`
                            }${unlocalizedCurrentPath()}`}
                            key={i}>
                            {' '}
                            {locale} {i === all.length - 1 ? '' : '|'}
                        </a>
                    ))}
                </div>
            );
        }
    };

    renderDevStuff = () => {
        if (IS_DEV) {
            return (
                <div className="conteneur conteneur-mobile">
                    <hr />
                    {this.renderDevLanguageLink()}
                </div>
            );
        }
    };

    renderSocialMedia = () => {
        const { i18n } = this.props;

        if (URL_PAGE_FACEBOOK || URL_PAGE_TWITTER || URL_PAGE_GOOGLEPLUS) {
            return (
                <div className="reseaux-sociaux">
                    <p className="bold hidden-mobonly">{i18n.TITLE_SMO}</p>
                    <div>
                        {URL_PAGE_FACEBOOK && (
                            <LocalizedNavLink
                                to={URL_PAGE_FACEBOOK}
                                target="_blank"
                                title={format(i18n.FACEBOOK_ICON, BRAND_NAME)}>
                                <img
                                    src={`${STATIC_ROOT}/facebook-rond.png`}
                                    alt={format(i18n.FACEBOOK_ICON, BRAND_NAME)}
                                    width="57"
                                    height="57"
                                />
                            </LocalizedNavLink>
                        )}
                        {URL_PAGE_TWITTER && (
                            <LocalizedNavLink
                                to={URL_PAGE_TWITTER}
                                target="_blank"
                                title={format(i18n.TWITTER_ICON, BRAND_NAME)}>
                                <img
                                    src={`${STATIC_ROOT}/twitter-rond.png`}
                                    alt={format(i18n.TWITTER_ICON, BRAND_NAME)}
                                    width="57"
                                    height="57"
                                />
                            </LocalizedNavLink>
                        )}
                        {URL_PAGE_GOOGLEPLUS && (
                            <LocalizedNavLink
                                to={URL_PAGE_GOOGLEPLUS}
                                target="_blank"
                                title={format(i18n.GOOGLEPLUS_ICON, BRAND_NAME)}>
                                <img
                                    src={`${STATIC_ROOT}/googleplus-rond.png`}
                                    alt={format(i18n.GOOGLEPLUS_ICON, BRAND_NAME)}
                                    width="57"
                                    height="57"
                                />
                            </LocalizedNavLink>
                        )}
                    </div>
                </div>
            );
        }
    };

    showCmp() {
        window.Didomi.preferences.show();
    }

    render() {
        const { i18n } = this.props;

        return (
            <footer className="pieddepage">
                <div className="conteneur conteneur-mobile">
                    <div className={`content grid-4 has-gutter`}>
                        <div>
                            <h3>{i18n.TITLE1}</h3>
                            <ul>
                                <li>
                                    <LocalizedNavLink
                                        to={PATH.FAQ_PATH}
                                        title={i18n.LINKS.FAQ.TITLE}>
                                        {i18n.LINKS.FAQ.TEXT}
                                    </LocalizedNavLink>
                                </li>
                                <li>
                                    <LocalizedNavLink
                                        to={PATH.CONTACTREQUEST_PATH}
                                        title={i18n.LINKS.CUSTOMER_SERVICE.TITLE}>
                                        {i18n.LINKS.CUSTOMER_SERVICE.TEXT}
                                    </LocalizedNavLink>
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h3>{i18n.TITLE2}</h3>
                            <ul>
                                <li>
                                    <LocalizedNavLink
                                        to={PATH.TERMS_PATH}
                                        title={i18n.LINKS.TERMS.TITLE}>
                                        {i18n.LINKS.TERMS.TEXT}
                                    </LocalizedNavLink>
                                </li>
                                <li>
                                    <LocalizedNavLink
                                        to={PATH.TERMS_OF_SALES}
                                        title={i18n.LINKS.TERMS_OF_SALES.TITLE}>
                                        {i18n.LINKS.TERMS_OF_SALES.TEXT}
                                    </LocalizedNavLink>
                                </li>
                                <li>
                                    <LocalizedNavLink
                                        to={PATH.LEGAL_NOTICE_PATH}
                                        title={i18n.LINKS.LEGAL_NOTICE.TITLE}>
                                        {i18n.LINKS.LEGAL_NOTICE.TEXT}
                                    </LocalizedNavLink>
                                </li>
                                <li>
                                    <span className="link" onClick={this.showCmp}>
                                        {i18n.CONSENT_CHOICES}
                                    </span>
                                </li>
                            </ul>
                        </div>
                        {this.renderSocialMedia()}
                    </div>
                </div>
                {this.renderDevStuff()}
            </footer>
        );
    }
}

FooterComponent.propTypes = {
    i18n: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n.FOOTER
    };
}

export default connect(mapStateToProps)(FooterComponent);



// WEBPACK FOOTER //
// ./src/components/footer/FooterComponent.js